<template>
  <Loading v-if="isLoading" />
  <div class="tit-group">
    <h2 class="tit">{{t('message.languageSetting')}}</h2>
  </div>
  <div class="content-box">

    <div class="sort-group">
      <div class="sort-row">
        <div class="wl">
          <c-btn02 :btnText="t('message.upload')" @click="onClickUpload"/>
          <c-btn02 :btnText="t('message.download')" @click="excelDownload"/>
          <input type="file" :ref="el => { excelFile = el }" :accept="'*'" @change="excelUpload" hidden/>
        </div>
        <div class="wr">
          <Select v-bind="versionSelect" v-model="versionModel"/>
          <!-- <c-btn01 :btnText="'언어추가'"/> -->
          <c-btn01 :btnText="t('message.save')" @click="dialogSaveModel=true"/>

        </div>
      </div>
    </div>
    <div class="tbl-group02">
      <table>
        <colgroup>
          <col style="width:10%">
          <col>
          <col style="width:20%">
          <col style="width:20%">
          <col style="width:20%">
          <col style="width:20%">
        </colgroup>
        <thead>
        <tr>
          <th>
            <div>{{t('message.module')}}</div>
          </th>
          <th>
            <div class="flex-l">{{t('message.item')}}</div>
          </th>
          <th>
            <div class="flex-r">
              <c-tooltip :TooltipText="t('message.languageChangeLabel')"/>
              <!-- <c-Input v-model="titles[0]" :name="'title0'"/> -->
              <input class="inp-ty" :value="titles[0]" @change="titles[0] = ($event.target as HTMLInputElement).value">
              </div>
          </th>
          <th>
            <div class="flex-r">
              <!-- <c-Input v-model="titles[1]" :name="'title1'"/> -->
              <input class="inp-ty" :value="titles[1]" @change="titles[1] = ($event.target as HTMLInputElement).value">
            </div>
          </th>
          <th>
            <div class="flex-r">
              <!-- <c-Input v-model="titles[2]" :name="'title2'"/> -->
              <input class="inp-ty" :value="titles[2]" @change="titles[2] = ($event.target as HTMLInputElement).value">
            </div>
          </th>
          <th>
            <div class="flex-r">
              <!-- <c-Input v-model="titles[3]" :name="'title3'"/> -->
              <input class="inp-ty" :value="titles[3]" @change="titles[3] = ($event.target as HTMLInputElement).value">
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in items" :key="item.module">
          <!--<td rowspan="2">-->
          <td>
            <div class="bold">{{ item.module }}</div>
          </td>
          <td>
            <div class="flex-l bold">{{item.title}}</div>
          </td>
          <td>
            <div class="flex-r">
              <!--<c-Input v-model.lazy="item.contentA" :name="'contentA'"/> -->
              <input class="inp-ty" :value="item.contentA" @change="item.contentA = ($event.target as HTMLInputElement).value">
            </div>
          </td>
          <td>
            <div class="flex-r">
              <!-- <c-Input v-model.lazy="item.contentB" :name="'contentB'"/> -->
              <input class="inp-ty" :value="item.contentB" @change="item.contentB = ($event.target as HTMLInputElement).value">
            </div>
          </td>
          <td>
            <div class="flex-r">
              <!-- <c-Input v-model.lazy="item.contentC" :name="'contentC'"/> -->
              <input class="inp-ty" :value="item.contentC" @change="item.contentC = ($event.target as HTMLInputElement).value">
            </div>
          </td>
          <td>
            <div class="flex-r">
              <!-- <c-Input v-model.lazy="item.contentD" :name="'contentD'"/> -->
              <input class="inp-ty" :value="item.contentD" @change="item.contentD = ($event.target as HTMLInputElement).value">
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
  <!--변경정보-->
  <c-dialog v-model="dialogSaveModel"
            v-bind="dialogSave"
            @confirm="onClickSave"
            @close="dialogSaveModel=false"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import LanguageService from "@/services/language.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import dayjs from "dayjs";
import CompanyService from "@/services/company.service";
import * as XLSX from "xlsx";
import MemberService from "@/services/member.service";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const isLoading = ref(false)
const excelFile = ref()
const snackbar = ref(false)
const snackText = ref('')
const versionSelect:any = ref({items: []})
const versionModel = ref('')
const dialogSaveModel = ref(false)
const items = ref([])
const titles = ref([])

//ui
const dialogSave= {
  dialogTit: t('message.notification'),
  dialogText: t('message.saveGeneratesNewVersion'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}

//watch
watch(versionModel, (newValue) => {
    getData()
})

//mount
onMounted(() => {
  getData()
})

const getData=async()=>{
  //언어팩 확인
  isLoading.value = true
  const companyIdx = localStorage.getItem('companyIdx')
  try {
    const response = await LanguageService.getLanguageListInSetting({companyIdx: companyIdx, version: versionModel.value})
    isLoading.value = false
    items.value = response.result.languages
    let versionList = response.result.versions
    versionSelect.value.items = []
    _.forEach(versionList, (item) => {
      versionSelect.value.items.push({name: `${item.version}-${item.memberId}(${dayjs(item.regDate).format('YYYY.MM.DD')})`, value: item.version})
    })
    if (utils.isEmpty(versionModel.value))
      versionModel.value = _.maxBy(versionList, 'version').version;
    titles.value = response.result.titles
  }
  catch (error) {
    isLoading.value = false
    if(error.status == 403)
      utils.movePage('/login')
    else
      utils.log(error)
  }
}

const onClickSave=async()=>{
  try{
    isLoading.value = true
    const companyIdx = localStorage.getItem('companyIdx')
    let params = {
      companyIdx: companyIdx,
      languages: items.value,
      titles: titles.value
    }
    const response = await LanguageService.insertLanguageList(params)
    if(response.success) {
      versionModel.value = response.result.lastVersion
      utils.syncLanguage()
    }
    else{
      snackText.value = response.message
      snackbar.value = true
    }
    isLoading.value = false
  }
  catch (error) {
    isLoading.value = false
    if(error.status == 403)
      utils.movePage('/login')
    else
      utils.log(error)
  }
}

const excelDownload=async(type)=>{
  let excelData = JSON.parse(JSON.stringify(items.value))

  const dataWS = XLSX.utils.json_to_sheet(utils.renameKeys(mapping, excelData))
  //const dataWS = XLSX.utils.json_to_sheet(excelData)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, dataWS, 'Sheet1')
  XLSX.writeFile(wb, 'language_list.xlsx')
}

const excelUpload=async()=>{
  snackText.value = ''
  const fileInfo = excelFile.value.files[0];
  let reader = new FileReader()
  reader.readAsArrayBuffer(fileInfo)
  reader.onload = async()=> {
    const fileData = reader.result
    const wb = XLSX.read(fileData, { type: "binary" })
    let toJson:any = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
    toJson = utils.renameKeys(mappingReverse, toJson)
    //업로드
    try{
      const companyIdx = localStorage.getItem('companyIdx')
      let params = {
        companyIdx: companyIdx,
        languages: toJson,
        titles: [toJson[0].shortA, toJson[0].shortB, toJson[0].shortC, toJson[0].shortD]
      }
      isLoading.value = true
      const response = await LanguageService.insertLanguageList(params)
      if(response.success) {
        versionModel.value = response.result.lastVersion
      }
      else{
        isLoading.value = false
        snackText.value = response.message
        snackbar.value = true
      }
    }
    catch (error) {
      isLoading.value = false
      if(error.status == 403)
        utils.movePage('/login')
      else {
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
        utils.log(error)
      }
    }
    excelFile.value.value = ''
  }
}

const onClickUpload=()=>{
  excelFile.value.click()
}

/** 엑셀 다운로드 시 rename될 mapping 양식 */
const mapping = {
  version: t('message.versionNoEdit'),
  moduleOrder: t('message.moduleOrderNoEdit'),
  module: t('message.moduleNameNoEdit'),
  variable: t('message.variableNameNoEdit'),
  title: t('message.titleNoEdit'),
  contentA: t('message.language1'),
  contentB: t('message.language2'),
  contentC: t('message.language3'),
  contentD: t('message.language4'),
  shortA: t('message.shortcut1'),
  shortB: t('message.shortcut2'),
  shortC: t('message.shortcut3'),
  shortD: t('message.shortcut4'),
}

const mappingReverse = {
  [t('message.versionNoEdit')]:'version',
  [t('message.moduleOrderNoEdit')]:'moduleOrder',
  [t('message.moduleNameNoEdit')]:'module',
  [t('message.variableNameNoEdit')]:'variable',
  [t('message.titleNoEdit')]:'title',
  [t('message.language1')]:'contentA',
  [t('message.language2')]:'contentB',
  [t('message.language3')]:'contentC',
  [t('message.language4')]:'contentD',
  [t('message.shortcut1')]:'shortA',
  [t('message.shortcut2')]:'shortB',
  [t('message.shortcut3')]:'shortC',
  [t('message.shortcut4')]:'shortD',
}

/*
const mappingReverse = computed(() => ({
  [t('message.versionNoEdit')]:'version',
  [t('message.moduleOrderNoEdit')]:'moduleOrder',
  [t('message.moduleNameNoEdit')]:'module',
  [t('message.variableNameNoEdit')]:'variable',
  [t('message.titleNoEdit')]:'title',
  [t('message.language1')]:'contentA',
  [t('message.language2')]:'contentB',
  [t('message.language3')]:'contentC',
  [t('message.language4')]:'contentD',
  [t('message.shortcut1')]:'shortA',
  [t('message.shortcut2')]:'shortB',
  [t('message.shortcut3')]:'shortC',
  [t('message.shortcut4')]:'shortD',
}))
 */
</script>
<style lang="scss" scoped>
.tbl-group .v-table .v-table__wrapper > table > tbody > tr > td:nth-child(2){width:30%;}
</style>
